module.exports = __webpack_public_path__ + "assets/xmcyber_com_dashboard.7a62e2cf.svg";